module.exports = __webpack_public_path__ + "static/img/key-r.9f39cc52.png";